import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InventoryModuleService } from '../services/inventory-module/inventory-module.service';

/**
 * Blocks direct navigation into Inventory routes while the global module switch is off.
 * Redirects to /pagenotfound (the feature doesn't exist here) rather than /unauthorized
 * (which PermissionGuard uses for actual permission denials).
 */
@Injectable({
  providedIn: 'root',
})
export class InventoryModuleGuard implements CanActivate {

  constructor(
    private inventoryModuleService: InventoryModuleService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    return this.inventoryModuleService.checkVisible().pipe(
      map((visible) => {
        if (!visible) {
          this.router.navigate(['/pagenotfound']);
          return false;
        }
        return true;
      }),
    );
  }
}
